import { Component, OnInit ,Input, Output ,ViewChild, ElementRef,EventEmitter } from '@angular/core';

import { GfichierService } from '../../service/gfichier.service';

@Component({
  selector: 'app-edittext',
  templateUrl: './edittext.component.html',
  styleUrls: ['./edittext.component.scss'],
})
export class EdittextComponent implements OnInit {
  
  
  public visibleMenu : boolean=true;
    
  
  //@ViewChild('content', {static: true}) content : ElementRef;

  @Input() content : string;
  @Input() id : number;
  @Input() key : string;
  
  
  
  @Output() eventchild = new EventEmitter<string>();
  
  
  @ViewChild('editable', {static: true}) editable : ElementRef;
  

   
  constructor(public gfichier : GfichierService) {
       
    
    
  }

  ngOnInit() {}

  ngOnChanges() {
    this.editable.nativeElement.innerHTML = this.content; 
  }

  enregistrer() {
    this.gfichier.setValue(this.editable.nativeElement.innerHTML,this.id,this.key); 
  
    this.eventchild.emit("enregistrer");

  }

  //*********** */

   private node:any;
   private position : number=0;
   
  //donne la position du curseur dans div editable
  //source https://jsfiddle.net/cpatik/3QAeC/
  getCaretPosition() {
    //let editable = document.getElementById('editable');
    let range = window.getSelection().getRangeAt(0);
    let selection = window.getSelection()
    this.node = selection.focusNode;//.parentNode
    this.position = range.startOffset;
     
    // this.caretPosition = this.getSelectionStartOffset(range, editable);  
      
        
        
  }//fin getposition curseur

 
  //positionne le curseur
  setCaretPosition() {
    //var element = document.getElementById("editable");
    let range = document.createRange();
    let sel =window.getSelection() ;
    if(!this.node) {
      document.getElementById("editable").focus();
      this.node = sel.focusNode;//.parentNode
      this.position = 0;
   }
    
    
    range.setStart(this.node, this.position);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
          
  
  
  }//fin setposition

  
  

  

styleTexte(commande:string) {
  this.setCaretPosition();
  if(commande=="h1") {
    //document.execCommand("styleWithCSS", 0 , true);
    document.execCommand('fontSize',true, '5');
  }
  else if(commande=="p1") {
    //document.execCommand("styleWithCSS", 0 , true);
    document.execCommand('fontSize',true, '3');
  }
  else
   document.execCommand(commande,false,null);
 
}


 


}
